// import { GenericsUtils } from "@/utils/generics.util";
import * as validators from "@vuelidate/validators";
import { createI18n } from "vue-i18n";
import { translateEN } from "./locations/en";
import { translatePT } from "./locations/pt";
const { createI18nMessage } = validators;

// const lang = new GenericsUtils().navigatorLanguage;

export const i18n = createI18n({
  locale: "pt",
  fallbackLocale: "pt-BR",
  messages: { ...translatePT, ...translateEN },
  legacy: false,
});

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) });
export const required = withI18nMessage(validators.required);
export const email = withI18nMessage(validators.email);
export const sameAs = withI18nMessage(validators.sameAs, {
  withArguments: true,
});
export const or = withI18nMessage(validators.or, { withArguments: true });
export const minLength = withI18nMessage(validators.minLength, {
  withArguments: true,
});
export const maxLength = withI18nMessage(validators.maxLength, {
  withArguments: true,
});

export default i18n;
